import { render } from "./BuyRequestDetail.vue?vue&type=template&id=a555da10&scoped=true"
import script from "./BuyRequestDetail.vue?vue&type=script&lang=js"
export * from "./BuyRequestDetail.vue?vue&type=script&lang=js"

import "./BuyRequestDetail.vue?vue&type=style&index=0&id=a555da10&lang=css"
import "./BuyRequestDetail.vue?vue&type=style&index=1&id=a555da10&lang=css"
import "./BuyRequestDetail.vue?vue&type=style&index=2&id=a555da10&lang=css"
import "./BuyRequestDetail.vue?vue&type=style&index=3&id=a555da10&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/FLOCKR/FLOCKER-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a555da10"]])

export default __exports__